<template>
  <div>
    <section class="content">
      <div ref="exportBigQuryPopup" class="exportBigQuryPopupWrapper">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modelpopContainer exportBigQuryPopup">
              <a class="close-btn" @click="closeexportBigQuryPopup()">
                <i class="fa fa-times" aria-hidden="true"></i>
              </a>
              <div class="clearfix">
                <div class="stepsheading expotbgheading">Export to Bigquery</div>
              </div>
              <div class="exportBqCheckbox clearfix">
                <div class="expotbgjobname">Job Name: {{currentExportName}}</div>
                <div class="error">{{bgQcheckerrormsg}}</div>
                <div class="checkbox">
                  <input
                    id="selall"
                    value="123"
                    type="checkbox"
                    v-on:change="exporttypeBqselctedAll()"
                  >
                  <label for="selall">Select All</label>
                </div>
                <div
                  ref="exportbgCompo"
                  class="checkbox"
                  v-for="(exporttypeBq) in exporttypeBq"
                  v-bind:key="exporttypeBq.id"
                >
                  <input
                    v-bind:checked="exporttypeBq.checked"
                    type="checkbox"
                    v-bind:ref="exporttypeBq.ref"
                    v-bind:id="exporttypeBq.ref"
                    class
                    v-bind:value="exporttypeBq.id"
                    @change="exporttypeBqselcted(exporttypeBq.id, exporttypeBq.checked)"
                    v-model="exporttypeBq.checked"
                  >
                  <label v-bind:for="exporttypeBq.ref">{{exporttypeBq.name}}</label>
                </div>
              </div>
              <div class="btnexporttobigqwrapper">
                <button class="btn btn-primary btn-large" rel="btnexporttobigq">Export</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Schedulejob ref="jobcompo" :showmodelprop="showmodelin">Test</Schedulejob>
      <vue-good-table
        ref="jobdashtable"
        @on-selected-rows-change="onDashPageChange"
        mode="local"
        :isLoading="isLoadingcompo"
        styleClass="table table-bordered condensed"
        :columns="columns"
        :rows="RowFilter"
        :paginate="false"
        :lineNumbers="true"
        :perPage="22"
        :sortable="true"
        :globalSearch="false"
        name="test"
      >
        <template slot="loadingContent">
          <span class="vgt-loading__content">
            <div class="dataspinner">
              <span>Loading Data</span>
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </span>
        </template>
        <template slot="table-row" slot-scope="props">
          <div class="td-wrapper">
            <div class="settingswrapper" v-if="props.column.field == 'name'">
              <button
                tabindex="-1"
                class="btn btn-sm btn-primary view-btn settingsBtn"
                @click="removeSelectedJobAlert(props.row, $event)"
                type="button"
              >
                <!-- <svg width="20" height="20" viewBox="0 -3 35 35" fill="#ffffff">
                  <g transform="scale(0.03125 0.03125)">openSetting(props, props.row, $event)
                    <path d="M933.79 610.25c-53.726-93.054-21.416-212.304 72.152-266.488l-100.626-174.292c-28.75 16.854-62.176 26.518-97.846 26.518-107.536 0-194.708-87.746-194.708-195.99h-201.258c0.266 33.41-8.074 67.282-25.958 98.252-53.724 93.056-173.156 124.702-266.862 70.758l-100.624 174.292c28.97 16.472 54.050 40.588 71.886 71.478 53.638 92.908 21.512 211.92-71.708 266.224l100.626 174.292c28.65-16.696 61.916-26.254 97.4-26.254 107.196 0 194.144 87.192 194.7 194.958h201.254c-0.086-33.074 8.272-66.57 25.966-97.218 53.636-92.906 172.776-124.594 266.414-71.012l100.626-174.29c-28.78-16.466-53.692-40.498-71.434-71.228zM512 719.332c-114.508 0-207.336-92.824-207.336-207.334 0-114.508 92.826-207.334 207.336-207.334 114.508 0 207.332 92.826 207.332 207.334-0.002 114.51-92.824 207.334-207.332 207.334z"></path>
                  </g>
                </svg>-->
                <i class="fa fa-trash"></i>
              </button>
              <!-- <div class="settingPopup" ref="settingPopup">
                <a class="closebtn" @click="settingPopupClose(props, props.row, $event)">
                  <i aria-hidden="true" class="fa fa-times"></i>
                </a>
                <button class="btnDelete" @click="removeSelectedJobAlert(props.row, $event)">
                  <i class="fa fa-trash"></i>
                </button>
                <button class="btnViewModel" @click="$emit('showModel', 'view', currentJobView), settingPopupClose()">
              <i class="fa fa-eye"></i>
            </button>
              </div>-->
            </div>

            <span class="btndownloadwrapper" v-if="props.column.field == 'download'">
              <button
                class="btn btndownload btn-sm btn-primary"
                @click="openexportbgPopuop (props.row)"
              >
                <i class="fa fa-download" aria-hidden="true"></i>
              </button>
            </span>
            <span v-else>{{props.formattedRow[props.column.field]}}</span>
          </div>
        </template>
      </vue-good-table>
    </section>
    <!-- <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert> -->
  </div>
</template>

<script>
import $ from 'jquery'
// var jQuery = $
// Require needed datatables modules
import VueGoodTable from '../../../node_modules/vue-good-table/src/components/Table.vue'
// import Simplert from 'vue2-simplert'
import Schedulejob from './Schedulejob.vue'
var loaddata = []
export default {
  name: 'Tables',
  components: {
    VueGoodTable,
    //  Simplert,
    Schedulejob
  },
  data () {
    return {
      RowFilter: [],
      exporttypeBq: [
        { name: 'Consumer Journey', id: '1', ref: 'ebginput1', checked: '' },
        {
          name: 'Weekly Consumer Journey',
          id: '2',
          ref: 'ebginput2',
          checked: ''
        },
        { name: 'Model Weights', id: '3', ref: 'ebginput3', checked: '' }
      ],
      selectallbqtype: false,
      viewButton: false,
      bgQcheckerrormsg: '',
      selectedBqType: [],
      currentExportName: '',
      currentExportJob: [],
      rows: loaddata,
      showmodelin: false,
      isLoadingcompo: true,
      columns: [
        {
          label: 'Name',
          field: 'name',
          type: 'text',
          html: false,
          filterable: false,
          width: '250px'
        },
        {
          label: 'ID',
          field: 'schedule_id',
          type: 'text',
          html: false,
          filterable: false,
          width: '350px'
        },
        {
          label: 'Client',
          field: 'client',
          html: true,
          filterable: false,
          width: '120px'
        },
        {
          label: 'Market',
          field: 'market',
          type: 'text',
          html: false,
          filterable: false
        },
        {
          label: 'Kpi',
          field: 'KPI',
          type: 'text',
          html: false,
          filterable: false
        },
        {
          label: 'Last Run Status',
          field: 'last_run_status',
          type: 'text',
          html: false,
          filterable: false,
          width: '150px'
        },
        {
          label: 'Last Run Date',
          field: 'last_run_date',
          html: false,
          filterable: false,
          width: '150px'
        },
        {
          label: 'User',
          field: 'user',
          html: false,
          filterable: false,
          hidden: true
        },
        {
          label: 'Reoccurrences',
          field: 'frequency',
          type: 'html',
          html: true,
          filterable: false,
          tdClass: 'status',
          filterDropdown: true,
          filterOptions: ['completed', 'created'],
          width: '120px'
        },
        {
          label: 'Download Reports',
          field: 'download',
          html: true,
          width: '160px',
          tdClass: 'text-center'
        },
        {
          label: 'parent_id',
          field: 'parent_id',
          hidden: true
        },
        {
          label: 'schedule_id',
          field: 'schedule_id',
          hidden: true
        }
      ]
    }
  },
  mounted () {
    this.$root.$on('DisplaySchedules', () => {
      this.filterfilldatatable()
    })
    var self = this
    var userchk = window.localStorage.getItem('user')
    if (userchk === undefined || userchk === '' || userchk === null) {
      self.$router.push('/login')
      return
    }
    // this.captureResponce()
    this.loadDatatoTable()
  },
  computed: {
    // exporttypeBq: {
  },
  created: function () {
    this.captureResponce()
  },
  watch: {
    RowFilter: function (o, n) {
      this.FillRowFilter()
      this.rows.filter(function (a) {
        console.log(a)
      })
      this.$refs.jobdashtable.resetTable()
      return this.rows
    }
    // exporttypeBq: {
    //   return this.exporttypeBq
    // }
  },
  methods: {
    loadDatatoTable () {
      var self = this
      var userchk = window.localStorage.getItem('user')
      if (
        this.$route.query.showmodel === 'true' ||
        this.$route.query.showmodel === true
      ) {
        this.$refs.jobcompo.modelpopupbuttonClick()
        return
      }
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VoyagerGetSchedules',
        data: { user_id: userchk },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // $('.dataspinner').show()
          //  self.isLoadingcompo = false
          self.$pingpong.hideloader()
        },
        success: function (data) {
          if (
            data.statusCode !== 200 ||
            data.statusCode === undefined ||
            data === undefined
          ) {
            self.displaypopuperr()
          }
          data = JSON.parse(data['user_schedules'])
          // var mydata = data[0]['name']
          // data[0]['name'] = [].concat(...mydata)
          if (!data.length) {
            let obj = {
              title: 'Please create a model',
              type: 'warning',
              customClass: 'warning'
            }
            self.$Simplert.open(obj)
          }
          console.log(data[0])
          self.rows = data
          self.filterfilldatatable()
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaypopuperr()
          // self.displaypopup()
        }
      })
    },
    filterfilldatatable () {
      var self = this
      self.RowFilter = []
      self.rows.filter(function (a) {
        console.log(a.client)
        if (
          window.localStorage.getItem('client') !== 'All Clients' &&
          window.localStorage.getItem('market') !== 'All Markets'
        ) {
          if (
            a.client === window.localStorage.getItem('client') &&
            a.selectedMarket === window.localStorage.getItem('market')
          ) {
            self.RowFilter.push(a)
          }
        }
        if (
          a.client === window.localStorage.getItem('client') &&
          window.localStorage.getItem('market') === 'All Markets'
        ) {
          if (a.client === window.localStorage.getItem('client')) {
            self.RowFilter.push(a)
          }
        }
        if (
          window.localStorage.getItem('client') === 'All Clients' &&
          window.localStorage.getItem('market') === 'All Markets'
        ) {
          self.RowFilter.push(a)
        }
      })
      self.rows.forEach(function (e, i) {
        // CurrentActiveJobID
        if (self.rows[i].status.toLowerCase() === 'completed') {
          self.CurrentActiveJobID = self.rows[i].id
          window.localStorage.setItem('jobid', self.CurrentActiveJobID)
        }
      })
    },
    FillRowFilter () {
      let rowfilter = this.rows
      rowfilter.filter(function (a) {
        console.log(a)
      })
      console.log(rowfilter)
      return rowfilter
    },
    deleteSchedule (cudata) {
      console.log(cudata)
      var self = this
      var userchk = window.localStorage.getItem('user')
      var scheduleid = cudata.schedule_id
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VoyagerDisableSchedule',
        data: { user_id: userchk, schedule_id: scheduleid, mode: 'disable' },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
        },
        success: function (data) {
          // data = JSON.parse(data['user_schedules'])
          // var mydata = data[0]['name']
          // data[0]['name'] = [].concat(...mydata)
          // console.log(data[0])
          // self.rows = data
          if (data.statusCode !== 200) {
            // self.downloadtriggerFailed()
          }
          self.deletetriggerSuccess()
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        }
      })
    },
    removeSelectedJobAlert (propsRow, evt) {
      let self = this
      let currentData = propsRow
      let confirmCloseModal = {
        title: 'Are you sure you want to delete Schedule?',
        type: 'info',
        useConfirmBtn: true,
        customConfirmBtnText: 'Yes',
        customCloseBtnText: 'No',
        customConfirmBtnClass: 'btn btn-primary',
        customCloseBtnClass: 'btn btn-primary',
        onConfirm: function () {
          self.deleteSchedule(currentData)
        }
      }
      this.$Simplert.open(confirmCloseModal)
    },
    openSetting (prps, entPointData, objevent) {
      console.log(prps, entPointData, objevent)
      let objectEvent = objevent
      console.log(objectEvent)
      if (
        objectEvent.currentTarget.nextElementSibling.className ===
        'settingPopup'
      ) {
        objectEvent.currentTarget.nextElementSibling.style.display = 'block'
        $('.settingsBtn').attr('disabled', 'disabled')
      }
    },
    settingPopupClose (prps, entPointData, objevent) {
      let objectEvent = objevent
      if (
        objectEvent.currentTarget.parentElement.className === 'settingPopup'
      ) {
        objectEvent.currentTarget.parentElement.style.display = 'none'
        $('.settingsBtn').removeAttr('disabled')
      }
    },
    displaypopuperr () {
      let obj = {
        title: 'Data Error',
        message: 'Please raise a Yammer message support.',
        type: 'error',
        customClass: 'error'
      }
      this.$Simplert.open(obj)
    },
    onDashPageChange () {
      console.log('test')
      this.isLoadingcompo = false
    },
    captureResponce () {
      console.log(this.$route.query.showmodel)
      // this.showmodelin = this.$route.query.showmodel
    },
    deletetriggerSuccess () {
      let obj = {
        title: 'Schedule deleted',
        message: '',
        type: 'success',
        onClose: this.refreshpage(),
        customClass: 'success'
      }
      this.$Simplert.open(obj)
    },
    refreshpage () {
      window.location.reload()
    },
    downloadtriggerSuccess () {
      let obj = {
        title: 'A email with download link will be sent shortly to you.',
        message: '',
        type: 'success',
        customClass: 'success'
      }
      this.$Simplert.open(obj)
    },
    downloadtriggerFailed () {
      let obj = {
        title: 'Last Job has failed or has not run',
        message: 'Please contact support on Yammer Group',
        type: 'error',
        customClass: 'error'
      }
      this.$Simplert.open(obj)
    },
    openexportbgPopuop (schdata) {
      // let obj = {
      //   title: 'Feature Coming Soon',
      //   message: 'Please checkout reports section to download reports',
      //   type: 'success',
      //   customClass: 'success'
      // }
      // this.$Simplert.open(obj)
      console.log(schdata)
      var self = this
      var rowdata = schdata
      var userchk = window.localStorage.getItem('user')
      var scheduleid = rowdata.schedule_id
      var parentid = rowdata.parent_id
      if (parentid === 'NA') {
        self.downloadtriggerFailed()
        return
      }
      // this.captureResponce()
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/voyagerreportbyemail',
        data: {
          'user-id': userchk,
          'schedule-id': scheduleid,
          'parent-id': parentid
        },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
        },
        success: function (data) {
          // data = JSON.parse(data['user_schedules'])
          // var mydata = data[0]['name']
          // data[0]['name'] = [].concat(...mydata)
          // console.log(data[0])
          // self.rows = data
          if (data.statusCode !== 200) {
            self.downloadtriggerFailed()
          }
          self.downloadtriggerSuccess()
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        }
      })
    }
  }
}
</script>

<style lang='scss'>
.btndownloadwrapper {
  display: block !important;
  text-align: center;
}
.btndownload {
  font-size: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  height: 40px;
  width: 40px;
}
td.vue-button span:after {
  content: '\F06E';
  display: inline-block;
  width: 10px;
  height: 10px;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-size: 20px;
  margin-left: 15px;
  position: relative;
  top: 2px;
  cursor: pointer;
}

.hideThforbutton {
  display: table-column;
  border-collapse: collapse;
}

.expotbgheading {
  width: 40%;
  max-width: 300px;
  float: left;
}
.expotbgjobname {
  width: 30%;
  margin: 20px 0 20px 20px;
  font-size: 20px;
}
.exportBqCheckbox .checkbox label {
  margin-left: 20px;
  user-select: none;
  font-size: 14px;
  line-height: 30px;
}
.exportBqCheckbox .checkbox input {
  margin-left: 20px !important;
  line-height: 30px;
  margin-top: 8px;
}
.btnexporttobigqwrapper {
  text-align: right;
  margin-right: 60px;
  margin-top: 60px;
}
.modelpopContainer.exportBigQuryPopup {
  width: 50vw;
  height: 30vw;
  min-height: 350px;
  min-width: 350px;
  position: relative;
}

.exportBqCheckbox {
  margin-top: 50px;
}
.exportBigQuryPopupWrapper {
  display: none;
}
.exportBigQuryPopupWrapper.active {
  display: block;
}
.exportBqCheckbox .error {
  margin-left: 21px;
  user-select: none;
}
.settingswrapper {
  position: absolute;
  right: 0px;
  display: block;
  top: 4px;
  bottom: auto;
  margin: auto;
}

.td-wrapper {
  position: relative;
  display: table;
  width: 100%;
  height: 40px;
  vertical-align: middle;
}
.td-wrapper span {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 40px;
}
.settingswrapper ~ span {
  /* display: table-cell; */
  /* width: calc(100% - 42px); */
  min-height: 40px;
  max-width: 180px;
  vertical-align: middle;
  width: 100%;
  text-align: left;
  height: 40px;
  /* overflow: hidden; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.settingPopup {
  position: absolute;
  width: 100px;
  top: -9px;
  right: -26px;
  border: 1px solid #232323;
  padding: 10px;
  background: RGBA(0, 0, 0, 0.6);
  transition: all 0.5s linear;
  height: 52px;
  z-index: 99;
  display: none;
  text-align: center;
  .closebtn {
    font-weight: 700;
    color: #fff;
    /* text-shadow: 0 1px 0 #fff; */
    position: absolute;
    top: -10px;
    right: -10px;
    display: inline-block;
    background: #000;
    border-radius: 100px;
    padding: 0px 6px;
    font-size: 15px;
    line-height: 24px;
    cursor: pointer;
  }
}

.settingPopup.active {
  height: 60px;
  width: 110px;
  display: block;
  transition: all 0.2s linear;
}
button.btnDelete {
  font-size: 20px;
}
.view-btn.settingsBtn {
  padding: 4px 8px;
  line-height: 15px;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// DisplayjobSchedule.vue?4178e2a6